// Feature Flags
export const FEATURES = {
  SPEECH_RECOGNITION: 'enableSpeechRecognition',
  TIMELINE: 'enableTimeline',
  STUDENT_PROFILES: 'enableStudentProfiles',
  CATEGORY_FILTERS: 'enableCategoryFilters'
};

// UI Constants
export const UI_CONSTANTS = {
  DEFAULT_PROFILE_IMAGE: '/api/placeholder/64/64',
  HIGHLIGHT_DURATION: 2000,
  TIMELINE_HEIGHT: '100px'
};

// Message Types
export const MESSAGE_TYPES = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  NEUTRAL: 'neutral'
};

// Analysis Constants
export const CATEGORIES = {
  DEFAULT: 'Personal Development',
  ALL: 'All'
};